export class Error {
	message: string = '';
}
